import { defineComponent, toRefs, ref, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsBaseInput/SdsBaseInput.vue.js';
import { useCurrencyDisplay } from './useCurrencyDisplay.js';

var script = defineComponent({
    name: 'SdsInputCurrency',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Number,
            required: false,
            default: undefined,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isReadOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        isClearable: {
            type: Boolean,
            required: false,
            default: false,
        },
        autocomplete: {
            type: String,
            required: false,
            default: undefined,
        },
        message: {
            type: String,
            required: false,
            default: undefined,
        },
        unit: {
            type: String,
            required: false,
            default: undefined,
        },
        shouldFillDecimals: {
            type: Boolean,
            required: false,
            default: true,
        },
        status: {
            type: String,
            required: false,
            default: undefined,
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: [
        'update:value',
        'click',
        'cleared',
        'focus',
        'blur',
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var _b = toRefs(props), value = _b.value, shouldFillDecimals = _b.shouldFillDecimals;
        var isFocused = ref(false);
        var baseInputRef = ref();
        var htmlInputRef = computed(function () { var _a; return (_a = baseInputRef.value) === null || _a === void 0 ? void 0 : _a.inputElementRef; });
        var _c = useCurrencyDisplay(value, shouldFillDecimals, htmlInputRef, function (value) { return emit('update:value', value); }), displayValue = _c.displayValue, handleKeyPress = _c.handleKeyPress, handleInput = _c.handleInput, handleInputBlur = _c.handleInputBlur, handleInputClick = _c.handleInputClick, handleBeforeInputEdgeCases = _c.handleBeforeInputEdgeCases;
        function setIsFocused(value, event) {
            isFocused.value = value;
            if (value) {
                emit('focus', event);
            }
            else {
                emit('blur', event);
                handleInputBlur();
            }
        }
        return {
            isFocused: isFocused,
            baseInputRef: baseInputRef,
            displayValue: displayValue,
            handleKeyPress: handleKeyPress,
            handleInput: handleInput,
            handleInputClick: handleInputClick,
            handleBeforeInputEdgeCases: handleBeforeInputEdgeCases,
            setIsFocused: setIsFocused,
        };
    },
    components: {
        SdsBaseInput: __vue_component__,
    },
});

export default script;
